"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amplifyConfig = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
exports.amplifyConfig = {
    Header: function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-amplify-header": true }, { children: (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("img", { alt: "GoldSpot Logo", src: "gs-logo-blue-letters.svg" }) }) })));
    },
    Footer: function () {
        var a = new Date().getFullYear();
        return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-amplify-footer": true }, { children: (0, jsx_runtime_1.jsxs)("p", { children: ["\u00A9", a, " GoldSpot Discoveries Corp. All Rights Reserved."] }) })));
    },
};
